"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_DESIGN_BOM_EVENTS = void 0;
var ACCESS_DESIGN_BOM_EVENTS;
(function (ACCESS_DESIGN_BOM_EVENTS) {
    ACCESS_DESIGN_BOM_EVENTS["ACCESS_DESIGN_BOM"] = "ACCESS_DESIGN_BOM";
    ACCESS_DESIGN_BOM_EVENTS["ACCESS_DESIGN_BOM_SUCCESS"] = "ACCESS_DESIGN_BOM_SUCCESS";
    ACCESS_DESIGN_BOM_EVENTS["ACCESS_DESIGN_BOM_ERROR"] = "ACCESS_DESIGN_BOM_ERROR";
})(ACCESS_DESIGN_BOM_EVENTS || (exports.ACCESS_DESIGN_BOM_EVENTS = ACCESS_DESIGN_BOM_EVENTS = {}));
